// 3rd party imports
import * as React from 'react';

// mobx
import { Program } from 'models';

// ui
import { UitkIcon } from 'uitk-react-icons';
import { UitkLayoutGrid, UitkLayoutGridItem } from 'uitk-react-layout-grid';
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkText } from 'uitk-react-text';
import { ILocalization } from '@shared-ui/localization-context';

export interface ProgramCardLobsProps {
  program: Program;
  l10n: ILocalization;
}

export const ProgramCardLobs: React.FunctionComponent<ProgramCardLobsProps> = ({ program, l10n }) => {
  const columns = program.lobs.length < 3 ? 1 : 2;
  const spaceFillers = new Array([3, 2, 1, 2, 2, 0, 0][program.lobs.length]).fill(
    <UitkSpacing margin={{ blockstart: 'one' }} padding={{ block: 'six' }}>
      <div />
    </UitkSpacing>,
  );

  return (
    <UitkLayoutGrid columns={{ small: columns, medium: columns }} space="two">
      {program.lobs.map((lob) => (
        <UitkSpacing key={lob.name} padding={{ blockstart: 'two' }}>
          <UitkLayoutGridItem>
            <div>
              <UitkText align="center">
                <UitkIcon name={lob.icon} />
              </UitkText>
              <UitkText align="center">{l10n.formatText(`programs.${program.name}.lobs.${lob.name}.name`)}</UitkText>
            </div>
          </UitkLayoutGridItem>
        </UitkSpacing>
      ))}
      {spaceFillers}
    </UitkLayoutGrid>
  );
};
